import React from "react";
import { ContentModeInfoModalTemplate } from "themes/application/payment/components";

function ContentModeInfoModal(props) {
    return <ContentModeInfoModalTemplate {...props} />;
}

export default ContentModeInfoModal;
